module.exports = __webpack_public_path__ + "images/294757ed.pay_7_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_7_kor.png
// module id = 580
// module chunks = 0